import {
  UserRoleLightDto,
  CreateSubscriptionUserRequest,
} from "@shared/types/common";

export default async (data?: object) => {
  const typedData = data as CreateSubscriptionUserRequest;
  return {
    ...typedData,
    status: "INVITED",
  } satisfies UserRoleLightDto;
};
